"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-play-16><path d="m4.836 1.18 9.6 5.83a1.15 1.15 0 0 1 0 1.98l-9.6 5.83c-.8.486-1.836-.072-1.836-.988V2.168C3 1.252 4.037.694 4.836 1.18Z"></path></symbol>';
}
